interface SlideFourProps {
    globalBanner: string;
    donationString: string;
}

export const SlideFour = ({ globalBanner, donationString }: SlideFourProps) => {
    return (
        <div class="slide slide-four">
            <div class="header">
                <img src={`https://${import.meta.env.VITE_MEDIA_HOST}/four-squares.svg`} alt="Inspired Logo" />
                <div>Plus More Great Causes!</div>
            </div>
            <div class="center-content">
                <img src={globalBanner} alt="more causes" />
            </div>
            <div class="footer">
                <div><strong>Unlock your free {donationString} donation to a cause of your choice.</strong></div>
                <div>Pick one after checkout.</div>
            </div>
        </div>
  );
};
